import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

interface UseGreetingParams {
  preferredName?: string | null;
}

interface GreetingOutput {
  hello: string;
  prompt: string;
  subtitle: string;
  hasName: boolean;
}

/**
 * Builds the welcome greeting based on the user's `preferredName`. Localized
 * via i18n keys `Agent.GreetingPersonal / GenericBrand / GreetingPrompt
 * / GreetingSubtitle`.
 */
const useGreeting = ({ preferredName }: UseGreetingParams): GreetingOutput => {
  const { t } = useTranslation();

  return useMemo(() => {
    const trimmed = preferredName?.trim();
    const hasName = !!trimmed;
    const hello = hasName ? t('Agent.GreetingPersonal', { name: trimmed }) : t('Agent.GenericBrand');
    const prompt = t('Agent.GreetingPrompt');
    const subtitle = t('Agent.GreetingSubtitle');

    return { hello, prompt, subtitle, hasName };
  }, [preferredName, t]);
};

export default useGreeting;
